import React, { useRef } from 'react';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { ContactItem } from '@zonofi/common';
import { Avatar } from '../../avatar';
import { chatStyles } from '@zonofi/chats-common/styles';
import { theme } from '@zonofi/common';
import { SHARED_SVGS } from '@zonofi/shared';
import './contact-view-all-popup.scss';

interface ContactViewAllPopupProps {
  contacts: ContactItem[];
  userName?: string;
  trigger: JSX.Element;
}

export const ContactViewAllPopup: React.FC<ContactViewAllPopupProps> = ({
  contacts,
  userName,
  trigger,
}) => {
  const ref = useRef<PopupActions>(null);

  const handleClose = () => {
    ref?.current?.close();
  };

  return (
    <Popup
      ref={ref}
      trigger={trigger}
      position="top left"
      arrow={false}
      closeOnDocumentClick={true}
      className="contact-view-all-popup"
    >
      <div className="contact-view-all-popup-content">
        {/* Header */}
        <div className="contact-view-all-popup-header">
          <img
            src={SHARED_SVGS.CloseCrossIcon}
            alt="Close"
            className="contact-view-all-popup-close"
            onClick={handleClose}
          />
          <span
            className="contact-view-all-popup-header-text comms-font-size-regular primary-font-semibold"
            style={chatStyles.fontSemiBold12}
          >
            Shared Contacts by{' '}
          </span>
          <span
            className="contact-view-all-popup-header-name comms-font-size-regular primary-font-regular"
            style={chatStyles.fontRegular12}
          >
            {userName || 'Unknown'}
          </span>
          {userName && (
            <Avatar
              id={userName}
              title={userName}
              variant="user"
              size="mini"
              className="contact-view-all-popup-header-avatar"
            />
          )}
        </div>

        {/* Contact List */}
        <div className="contact-view-all-popup-list">
          {contacts.map((contact, index) => (
            <div
              key={index}
              className={`contact-view-all-popup-item ${
                index < contacts.length - 1
                  ? 'contact-view-all-popup-item-border'
                  : ''
              }`}
            >
              <div className="contact-view-all-popup-item-content">
                <Avatar
                  id={contact.phoneNumber || contact.displayName || '-'}
                  title={contact.displayName || 'Unknown'}
                  variant="user"
                  size="small"
                  className="contact-view-all-popup-item-avatar"
                />
                <div className="contact-view-all-popup-item-info">
                  <div
                    className="contact-view-all-popup-item-name comms-font-size-regular primary-font-regular"
                    style={chatStyles.fontRegular14}
                  >
                    {contact.displayName || 'Unknown Contact'}
                  </div>
                  {contact.phoneNumber && (
                    <div
                      className="contact-view-all-popup-item-phone comms-font-size-small primary-font-regular"
                      style={{
                        ...chatStyles.fontRegular12,
                        color: theme.text.secondary,
                      }}
                    >
                      {contact.phoneNumber}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Popup>
  );
};
